export const EntityTypes = [
    'item',
    'property',
    'lexeme',
    'form',
    'sense',
    'entity-schema',
];
//# sourceMappingURL=entity.js.map